import React, {useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../../common/AbstractListView";
import periodCloseIcon from '../../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../../img/periodclose-12.svg';
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../../uiControls/CurrencyLabel';
import {JobNames} from "../../../../framework.core/JobNames";
import {bankTransferList} from "../../tableSettings";
import {BankTransferListItem} from "../../../../fms.data/models/BankTransferListItem";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import { FmsSecTask } from '../../../../fms.core/constants';
import { SuntekSettings, SystemSettings } from '../../../../ifmsTypes';
import { findSecurityTask, getSecBySecTask } from '../../../../util';
import { useJournal } from '../../general/journal/JournalListView';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../../ui/ActionButton';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import { SecType } from '../../../../fms.enum';
import { faPlus} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, ViewIconButton, ViewIconButton2 } from '../../../../ui/IconButton';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    
  </div>;
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  // const sourceUrl = `${history.location.pathname}${history.location.search}`;
  const operation = 'accounting';

  const selectedElement = jobListContext.selectedElement as BankTransferListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankTransfer/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, `/${operation}/acBankTransfer/add`, NavigationType.newPage);
  }

  async function deleteEntity() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankTransfer/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankTransfer/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bank Transfer first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.BankTransfer, {
        id: selectedElement.id,
        pimsLinkId: 0
      });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acBankTransfer/edit/${id}`;
    const viewUrl = `/${operation}/acBankTransfer/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/acBankTransfer/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acBankTransfer/edit/${id}`;
    const viewUrl = `/${operation}/acBankTransfer/view/${id}`;

    const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankTransfer);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankTransfer/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/acBankTransfer/add?copyId=${id}`, NavigationType.newPage);
  }

  return {create, deleteEntity, edit, view, copy, operation};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteEntity, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);  
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankTransfer);
  const isVoid = jobListContext.selectedElement.void;

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd  },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel || isVoid, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="bankTransfer-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteEntity();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}



function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  const selectedElement = jobListContext.selectedElement as BankTransferListItem;
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankTransfer);

  const { edit, view, deleteEntity, operation} = useSelectedOperations();
  const {switchJournal} = useJournal();

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankTransfer/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acBankTransfer/view/${id}`);
  }

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read) && !userId.startsWith('@');

  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='bankTransfer-list-add-button' display="primary" link={`/${operation}/acBankTransfer/add`} disabled={!canBeAdd} label={<FontAwesomeIcon icon={faPlus} />} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='bankTransfer-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='bankTransfer-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='bankTransfer-list-delete-button' disabled={!canBeDeleted} onClick={deleteEntity} useText/>
      </div>
      {!checkSecJournal && <JournalIconButton onClick={() => switchJournal(JobNames.BankTransfer, selectedElement.id)} useText/>}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);  
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctBankTransfer);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();

  const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'F3', 'F9','F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  
  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportMbl}
      jobName={JobNames.BankTransfer}
      //entityId={(jobListContext.selectedElement as OeMblListItem | null)?.id}
      jobId={(jobListContext.selectedElement as BankTransferListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as BankTransferListItem;
  // const {switchJournal} = useJournal();
  // const appContext = useContext(ApplicationContext);
  
  // if (!getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read) && !userId.startsWith('@')) {
  //   return null;
  // }

  // return (
  //   <JournalIconButton onClick={() => switchJournal(JobNames.BankTransfer, selectedElement.id)} useText/>
  // );
  return  null;
}

/**
 * Concrete implementation for Quotation List screen
 *
 * @class BankTransferListView
 * @extends {AbstractListView}
 */
class BankTransferListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.BankTransfer,
      'BankTransferListItem',
      BankTransferListItem.calculateSearchParameters(search, BankTransferListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: BankTransferListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
      const apiResult = await api.getListItems(JobNames.BankTransfer, 'BankTransferListItem',
      BankTransferListItem.calculateSearchParameters(search, BankTransferListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return BankTransferListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      {accessor: 'status', Cell: IndicatorRenderer},
      {accessor: 'u2Date', Cell: DateTimeRenderer},
      {accessor: 'u1Date', Cell: DateTimeRenderer},
      {accessor: 'postDate', Cell: DateRenderer},
      // {accessor: 'void', Cell: NullableCheckboxIconRenderer, Header: () => <div data-tooltip="Void">V</div>},

      {accessor: 'fBankName', Cell: TextAlignLeftRenderer},
      {accessor: 'fBranch', Cell: TextRenderer},
      {accessor: 'fCurrency', Cell: TextRenderer},
      {accessor: 'tBankName', Cell: TextAlignLeftRenderer},
      {accessor: 'tBranch', Cell: TextRenderer},
      {accessor: 'tCurrency', Cell: TextRenderer},
      {accessor: 'fAmount', Cell: FloatRenderer},
      {accessor: 'remark', Cell: TextAlignLeftRenderer},
      {accessor: 'u1Id', Cell: TextAlignLeftRenderer},
      {accessor: 'u2Id', Cell: TextAlignLeftRenderer},
    ];
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  bankTransferList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = BankTransferListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }
  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: BankTransferListItem) {
    return row && row.id ? `/accounting/acBankTransfer/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Bank Transfer List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.BankTransfer} keyProp='id' showAdjustBalance={false} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default BankTransferListView;
